import { Icon } from '@scale/scaleui';
import { EditorEvents, useCurrentEditor } from '@tiptap/react';
import { useCallback, useEffect, useState } from 'react';
import { CopilotTransactions } from '../../plugins/ReviewerCopilot';

export function ReviewerCopilotButton() {
  const { editor } = useCurrentEditor();
  const [isEnabled, setIsEnabled] = useState<boolean>(false);
  useEffect(() => {
    if (!editor) return;
    function handleTransaction(event: EditorEvents['transaction']) {
      const enabledChange = event.transaction.getMeta(CopilotTransactions.ENABLED_CHANGE);
      if (enabledChange !== undefined) {
        setIsEnabled(enabledChange);
      }
    }
    editor.on('transaction', handleTransaction);
    return () => {
      editor.off('transaction', handleTransaction);
    };
  }, [editor]);

  const handleCopilotClick = useCallback(() => {
    if (!editor) return;
    if (!editor.state.selection.empty) {
      editor
        .chain()
        .focus()
        .setCopilotSelection({
          empty: false,
          from: editor.state.selection.from,
          to: editor.state.selection.to,
          text: editor.state.doc.content.textBetween(
            editor.state.selection.from,
            editor.state.selection.to,
          ),
        })
        .setCopilotOpen(true)
        .run();
    }
  }, [editor]);
  if (!editor || !isEnabled) return null;
  return (
    <div className="p-2">
      <Icon
        tooltip="Fact Checker"
        tooltipProps={{
          delayDuration: 0,
        }}
        onClick={handleCopilotClick}
        icon="magnifying-glass"
        size="sm"
      />
    </div>
  );
}
